import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import configData from "../config.json";
import "./Abha.css";
export default class ConsentdivlectionAadhaar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      textexpanded: false,
      aadharNumber: ["", "", ""], // for the 3 parts
      showAadhaar: false,
      checkboxChecked: false,
      checkboxTwo: false,
      checkboxThree: false,
      checkboxFour: false,
      checkboxFive: false,
      checkboxSix: false,
      checkboxSeven: false,
      isSubmitting: false,
      authenticationtype: "aadharotp",
    };
  }
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg); // 'warn' is used instead of 'warning'
        break;
      default:
        toast.info(msg);
    }
  };
  toggleReadMore = () => {
    this.setState((prevState) => ({ textexpanded: !prevState.textexpanded }));
  };
  handleaadhaarchange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ aadharNumber: fieldValue });
  };

  HandleSubmit = (e) => {
    e.preventDefault();

    const {
      aadharNumber,
      checkboxChecked,
      checkboxTwo,
      checkboxThree,
      checkboxFour,
      checkboxFive,
      checkboxSix,
      checkboxSeven,
      authenticationtype,
    } = this.state;
    const fullAadhaar = aadharNumber.join("");
    if (fullAadhaar.trim() === "") {
      this.showToast("Aadhaar number is required.", "error");
      return;
    }
    const aadhaarRegex = /^\d{12}$/;
    if (!aadhaarRegex.test(fullAadhaar)) {
      this.showToast(
        "Aadhaar must be 12 digits long and contain only numbers.",
        "error"
      );
      return;
    } else if (!authenticationtype || authenticationtype.trim() === "") {
      this.showToast("Please Select Authentication Type", "error");
      return false;
    }

    const checkboxErrors = [
      {
        checked: checkboxChecked,
        message: "Please agree to the first consent box.",
      },
      {
        checked: checkboxTwo,
        message: "Please agree to the second consent box.",
      },
      {
        checked: checkboxThree,
        message: "Please agree to the third consent box.",
      },
      {
        checked: checkboxFour,
        message: "Please agree to the fourth consent box.",
      },
      {
        checked: checkboxFive,
        message: "Please agree to the fifth consent box.",
      },
      {
        checked: checkboxSix,
        message: "Please agree to the sixth consent box.",
      },
      {
        checked: checkboxSeven,
        message: "Please agree to the seventh consent box.",
      },
    ];

    for (let i = 0; i < checkboxErrors.length; i++) {
      if (!checkboxErrors[i].checked) {
        this.showToast(checkboxErrors[i].message, "warning");
        return;
      }
    }

    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("aadharNumber", fullAadhaar);

    fetch(configData.api_url + "C_Abhadetails/add", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          window.location.href = "/aadhaarauthentication";
          sessionStorage.setItem("requestId", data.requestId);
          sessionStorage.setItem("message", data.details.message);
        }
        this.setState({
          aadhaarNumber: "",
          isSubmitting: false,
        });
      });
  };
  onKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
      toast.error("Spaces are not allowed.");
    }
  };
  handleAadhaarPartChange = (index, value) => {
    const cleanValue = value.replace(/\D/g, "").slice(0, 4); // Only digits, max 4
    const updated = [...this.state.aadharNumber];
    updated[index] = cleanValue;
    this.setState({ aadharNumber: updated }, () => {
      if (
        cleanValue.length === 4 &&
        index < this.state.aadharNumber.length - 1
      ) {
        const nextInput = document.getElementById(`aadharNumber-${index + 1}`);
        if (nextInput) nextInput.focus();
      }
    });
  };
  handleKeyDownAadharNumber = (idx, e) => {
    if (e.key === "Backspace" && !this.state.aadharNumber[idx] && idx > 0) {
      document.getElementById(`aadharNumber-${idx - 1}`).focus();
    }
  };
  toggleAadhaarVisibility = () => {
    this.setState({ showAadhaar: !this.state.showAadhaar });
  };
  handleAuthChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ authenticationtype: fieldValue });
  };
  render() {
    return (
      <div>
        <div className="row mb-2" id="flowStyle">
          <div className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Aadhaar Authentication</p>
            </div>
          </div>
          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Communication Details</p>
            </div>
          </div>
          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA Address Creation</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center text-center consentCollectionAadhaar">
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form>
                <Form.Group>
                  <Form.Label>
                    <b>Enter Your Aadhaar Number</b>
                  </Form.Label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    {this.state.aadharNumber.map((val, idx) => (
                      <Form.Control
                        id={`aadharNumber-${idx}`}
                        className="formselect"
                        style={{
                          textAlign: "center",
                        }}
                        type={this.state.showAadhaar ? "text" : "password"}
                        maxLength={4}
                        value={val}
                        onChange={(e) =>
                          this.handleAadhaarPartChange(idx, e.target.value)
                        }
                        tabIdx={idx + 1}
                        onKeyDown={(e) =>
                          this.handleKeyDownAadharNumber(idx, e)
                        }
                      />
                    ))}
                    <Button
                      variant="outline-secondary"
                      style={{
                        width: "50px",
                        height: "40px",
                        fontSize: "18px",
                      }}
                      className={`rounded-0 bi ${
                        this.state.showAadhaar ? "bi-eye-slash" : "bi-eye"
                      }`}
                      onClick={() =>
                        this.setState({ showAadhaar: !this.state.showAadhaar })
                      }
                    />
                  </div>
                </Form.Group>
                <Form.Group
                  style={{
                    padddingTop: "10px",
                  }}
                >
                  <Form.Label className="authenticationType">
                    <b>Authentication Type</b>
                  </Form.Label>
                  <Form.Control
                    name="authenticationtype"
                    className="formselect"
                    as="select"
                    aria-label="Default select example"
                    value={this.state.authenticationtype}
                    onChange={this.handleAuthChange}
                  >
                    <option value="aadharotp" default>
                      Aadhaar OTP
                    </option>
                  </Form.Control>
                </Form.Group>
                <p className="aadhaarOTP_paragraph">
                  Please ensure that mobile number is linked with Aadhaar as it
                  will be required for OTP authentication. If you do not have a
                  mobile number linked, visit the nearest ABDM participating
                  facility and seek assistance.
                </p>
              </Form>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2 herebyDeclareParagraph">
          <div className="col">
            <Form.Group>
              <p>I hereby declare that:</p>
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxChecked"
                id="nonelectricalaccessories"
                label="I am voluntarily sharing my Aadhaar Number / 
                Virtual ID issued by the Unique Identification Authority 
                of India (“UIDAI”), and my demographic information for the purpose of 
                creating an Ayushman Bharat Health Account number (“ABHA number”) 
                and Ayushman Bharat Health Account address (“ABHA Address”).
                 I authorize NHA to use my Aadhaar number / Virtual ID
                  for performing Aadhaar based authentication with UIDAI 
                  as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, 
                  Benefits and Services) Act, 2016 for the aforesaid purpose.
                I understand that UIDAI will share my e-KYC details,
                 or response of “Yes” with NHA upon successful authentication."
                checked={this.state.checkboxChecked}
                onChange={(e) =>
                  this.setState({ checkboxChecked: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxTwo"
                id="nonelectricalaccessories"
                label="I intend to create Ayushman Bharat Health Account Number (“ABHA number”) 
                and Ayushman Bharat Health Account address (“ABHA Address”) using document other 
                than Aadhaar. (Click here to proceed further)
"
                checked={this.state.checkboxTwo}
                onChange={(e) =>
                  this.setState({ checkboxTwo: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxThree"
                id="nonelectricalaccessories"
                label="I consent to usage of my ABHA address and ABHA number 
                for linking of my legacy (past) government health records and those which will be generated during this encounter.
"
                checked={this.state.checkboxThree}
                onChange={(e) =>
                  this.setState({ checkboxThree: e.target.checked })
                }
              />

              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxFour"
                id="nonelectricalaccessories"
                label="I authorize the sharing of all my health records with healthcare provider(s)
                 for the purpose of providing healthcare services to me during this encounter."
                checked={this.state.checkboxFour}
                onChange={(e) =>
                  this.setState({ checkboxFour: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxFive"
                id="nonelectricalaccessories"
                label="I consent to the anonymization and subsequent use of my 
                government health records for public health purposes"
                checked={this.state.checkboxFive}
                onChange={(e) =>
                  this.setState({ checkboxFive: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxSix"
                id="nonelectricalaccessoriess"
                label="I, (Apna Policy Insurance Brokers Private Limited ), confirm that I have duly informed 
                and explained the beneficiary of the contents of consent for aforementioned purposes.
"
                checked={this.state.checkboxSix}
                onChange={(e) =>
                  this.setState({ checkboxSix: e.target.checked })
                }
              />
              <Form.Check
                style={{ font: "inherit" }}
                type="checkbox"
                className="label"
                name="checkboxSeven"
                id="nonelectricalaccessories"
                label={`I,(${
                  this.state.consentName || " ______ "
                }) have been explained about the consent as stated above and hereby provide my consent for the aforementioned purposes`}
                checked={this.state.checkboxSeven}
                onChange={(e) =>
                  this.setState({ checkboxSeven: e.target.checked })
                }
              />
            </Form.Group>
          </div>
          <Form.Group controlId="consentName">
            <Form.Control
              type="text"
              placeholder="Enter your name _________"
              value={this.state.consentName}
              onChange={(e) => this.setState({ consentName: e.target.value })}
            />
          </Form.Group>
        </div>

        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
            <Button className="rounded-0 m-1 " variant="warning">
              Cancel
            </Button>
            <Button
              className="rounded-0 m-1"
              disabled={this.state.isSubmitting}
              onClick={this.HandleSubmit}
            >
              {this.state.isSubmitting ? "Submitting..." : "Next"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
